import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 22,
    height: 22
  }
});

class IcFacebook extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    titleAccess = 'Facebook'
                    viewBox = { "0 0 22 22" } >
      <path d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z" fill="#4272b8"/>
      <path d="M12.1466 17.4678V11.4832H13.7986L14.0175 9.42086H12.1466L12.1494 8.38865C12.1494 7.85076 12.2005 7.56255 12.973 7.56255H14.0058V5.5H12.3536C10.369 5.5 9.67042 6.50045 9.67042 8.18288V9.42109H8.43335V11.4834H9.67042V17.4678H12.1466Z" fill="#ffffff"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcFacebook);